export function getCodeFromShiftRecordId(shiftRecordId) {
  if (!shiftRecordId) throw new Error('Không có shiftRecordId')
  const outletCode = shiftRecordId.slice(0, 3).replace('_', '')
  // console.log(outletCode)
  return outletCode
}
